import React, { useState } from "react";
import NuAmount from "../../../../../../Components/Utils/NuAmount";
import ViewMore from "./ViewMore";


const ExpandableMaterialPro = ({data,getData, titleId, selectedExpandedItems, onExpandedCheckboxChange,projectId,Category,Division,Unit,Item,itemsCategory ,Activity}) => {
  // console.log('====================================');
  // console.log(titleId,"jjjj");
  // console.log('====================================');

  

  return (
    <>
    {
        data.map((item, index) => (
            <tr className={`w-[100%] bg-white text-xs font-normal text-[#71797E]`} style={{borderBottom:'1px solid #c7dfe0'}} key={index}>
            <td className=" w-[5%] py-3 px-1  text-left">
                <div className=" w-full gap-1 flex">
                <input 
            type="checkbox" 
            checked={selectedExpandedItems[titleId]?.includes(item.materialId) || false}
            onChange={() => onExpandedCheckboxChange(titleId, item.materialId)}
            />
                {index+1}
                </div>
            </td>
            <td className=" w-[20%] py-3 px-1">{item?.item||"-"}</td>
            <td className=" w-[9%] py-3 px-1">{item?.category||"-"}</td>
            <td className=" w-[9%] py-3 px-1">{item?.division||"-"}</td>
            <td className=" w-[14%] py-3 px-1">{<NuAmount value={item?.quantity||0}/>}</td>
            <td className=" w-[9%] py-3 px-1">{item?.unit||"-"}</td>
            <td className=" w-[14%] py-3 px-1">{<NuAmount value={item?.amount||0}/>}</td>
            {/* <td className=" w-[15%] py-3 px-1">{<NuAmount value={item?.hours||0} />}</td> */}
            <td className=" w-[5%] py-3 pl-3">
                         <ViewMore 
                            id={ data.id|| ""}
                            getData={getData}
                            data={item}
                            projectId={projectId}
                            Category={Category}
                            Unit={Unit}
                            Division={Division}
                            Item={Item}
                            itemsCategory={itemsCategory}
                            Activity={Activity}
        
                            /> 
            </td>
           </tr>
        ))
    }
    </>
  );
};

export default ExpandableMaterialPro;
